import React from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";

import Column from "../components/MainMenuDropdown/components/Column";
import MainMenuLink from "../components/MainMenuDropdown/components/MainMenuLink";
import MainMenuDropdown from "../components/MainMenuDropdown";

import { useStore } from "../../../connect";

import strings from "../../../locales/strings";

const DocsDropdown = ({ isMobile }) => {
  const { profile } = useStore();

  return (
    <MainMenuDropdown isMobile={isMobile}>
      <Column title={strings.menu_section_yourDocuments}>
        <MainMenuLink
          name="docs-inbox"
          isCounterActive
          counter={profile.counters.docsInbox}
        />
        <MainMenuLink
          name="docs-awaiting-decision"
          counter={profile.counters.docsAwaitingDecision}
        />
        <MainMenuLink
          name="docs-closing"
          counter={profile.counters.docsClosing}
        />
      </Column>
      <Column title={strings.menu_section_createDocument}>
        <MainMenuLink name="docs-application-agreement" />
        <MainMenuLink name="docs-certificate-of-completion" />
        <MainMenuLink name="docs-invoice" />
        <MainMenuLink name="docs-other-document" />
      </Column>
      <Column title={strings.menu_section_rouming}>
        <MainMenuLink
          name="docs-your-counterparties"
          isCounterActive
          counter={profile.counters.docsYouAreInvited}
        />
        <MainMenuLink name="docs-your-certificates" />
      </Column>
    </MainMenuDropdown>
  );
};

DocsDropdown.propTypes = {
  isMobile: PropTypes.bool,
};

export default observer(DocsDropdown);
